<script>
  import Button from './button.svelte';

  export let backgroundImage;
  export let header;

</script>

<div class="card" style="background-image: url('../images/backgrounds/{backgroundImage}');">
  <div class="content" style="left: 34px; text-align: left;">
    <h1>{@html header}</h1>
  </div>
</div>


<style>
  .card {
    font-family: 'Oswald', sans-serif;
    position: relative;
    background-size: cover;
    background-position: center;
    height: 400px; /* Adjust as needed */
    display: flex;
    align-items: flex-end;
    padding: 20px;
  }

  .content {
    position: absolute;
    bottom: 70px;
    color: white; /* Adjust text color as needed */
  }

  .content h1 {
    font-size: 3.4rem; /* Adjust title size as needed */
    margin: 0 0 10px 0;
  }
</style>